import { render } from "./EspeciesHome.vue?vue&type=template&id=2112565f&scoped=true"
const script = {}

import "./EspeciesHome.vue?vue&type=style&index=0&id=2112565f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2112565f"]])

export default __exports__